var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"knowledges"},[(_vm.type === 'question')?_c('div',[_c('h6',[_vm._v("O que a "+_vm._s(_vm.materialType)+" cobra:")]),(
        _vm.material &&
          _vm.material.knowledges &&
          _vm.material.knowledges.summative &&
          _vm.material.knowledges.summative.length > 0
      )?_c('ul',_vm._l((_vm.material.knowledges.summative),function(knowledge){return _c('li',{key:knowledge.id},[_c('p',[_vm._v(_vm._s(knowledge.name))])])}),0):_c('p',[_vm._v("Essa "+_vm._s(_vm.materialType)+" não cobra conhecimentos")])]):_vm._e(),_c('div',[_c('h6',[_vm._v("O que a "+_vm._s(_vm.materialType)+" ensina:")]),(
        _vm.material &&
          _vm.material.knowledges &&
          _vm.material.knowledges.formative &&
          _vm.material.knowledges.formative.length > 0
      )?_c('ul',_vm._l((_vm.material.knowledges.formative),function(knowledge){return _c('li',{key:knowledge.id},[_c('p',[_vm._v(_vm._s(knowledge.name))])])}),0):_c('p',[_vm._v("Essa "+_vm._s(_vm.materialType)+" não ensina conhecimentos")])])])}
var staticRenderFns = []

export { render, staticRenderFns }